export default __webpack_public_path__ + "static/screeny-110-gc-cabrio-8-5d9a8c4df687d9f2437222876f265d49.jpg";